import { render, staticRenderFns } from "./M15-BestsellerCard.vue?vue&type=template&id=43fbe172"
import script from "./M15-BestsellerCard.vue?vue&type=script&lang=js"
export * from "./M15-BestsellerCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports